import React from 'react';
import style from '../TreeNavigationMenu.scss';
import classnames from 'classnames';
import { sectionPrefix } from '../../../utils';
import ChevronRightSmall from 'wix-ui-icons-common/ChevronRightSmall';
import { ActiveLink } from '../../../../ActiveLink';
import { NAV_TYPES } from '../../../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { CustomLink } from '../../../../PageElements/CustomLink';
import { Text } from 'wix-style-react';

export const SubTreeLink = ({
  urlFormat,
  onClick,
  name,
  prefix,
  shouldRenderSubTree,
  depth,
}) => {
  const getUrl = () => {
    return `/${sectionPrefix(prefix, urlFormat)}`;
  };

  return (
    <div className={style.subTreeLinkWrapper} data-hook={getUrl()}>
      <ActiveLink>
        {({ isActive }) => (
          <CustomLink
            className={classnames({
              [style.subTreeLink]: true,
              [style.active]: shouldRenderSubTree,
              [style[`depth-${depth}`]]: true,
              [style.focusItem]: isActive(getUrl()),
            })}
            to={{
              pathname: `/${sectionPrefix(prefix, urlFormat)}`,
              state: { navType: NAV_TYPES.MENU_CATEGORY },
            }}
            onClick={() => onClick(urlFormat)}
          >
            <ChevronRightSmall
              size="20px"
              className={classnames({
                [style.chevron]: true,
                [style.active]: shouldRenderSubTree,
                [style[`depth-${depth}`]]: true,
              })}
            />
            <Text
              dataHook="sub-tree-link"
              size="small"
              weight="normal"
              secondary
              ellipsis
              placement="right"
              className={style.textContainer}
            >
              {name}
            </Text>
          </CustomLink>
        )}
      </ActiveLink>
    </div>
  );
};
